import { HttpService } from '@app/model/_common/service/HttpService';

type ReportExecutionDownload = {
	execution: {
		id: number;
		filename?: string | null;
	};
	report: {
		name: string;
	};
};

class ExportService {
	public static async downloadFile(reportExport: ReportExecutionDownload, fileName: string): Promise<void> {
		try {
			const url = `/api/market-state/export/${reportExport.execution.id}`;
			const blob = await HttpService.getBlob(url);
			const downloadUrl = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = downloadUrl;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(downloadUrl);
		} catch (error) {
			console.error('Error downloading file from S3:', error);
			alert('Failed to download file. Please try again.');
		}
	}
}

export default ExportService;
